export default "__VITE_ASSET__58aa79f3__"